import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    userDataItems: [],
    itemBrandsItems: [],
    itemTypesItems: [],
    itemCategoriesItems: [],
    priceGroupsItems: [],
    measuresItems: [],
    vatRatesItems: [],
    casesItems: []
  },
  actions,
  getters,
  mutations
}
